"use client";
import "../../../chunk-MMUBH76A.js";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { CpslHero, CpslIcon, CpslIdenticon } from "@getpara/react-components";
import styled from "styled-components";
import { ModalStep } from "../../utils/steps.js";
import { useModalStore } from "../../stores/index.js";
import { useExternalWallets } from "../../providers/ExternalWalletContext.js";
import { NETWORK_NOT_SUPPORTED_ERROR } from "../../constants/constants.js";
import { useEffect, useState } from "react";
import { isMobile } from "@getpara/web-sdk";
import { useActiveWallet } from "../../hooks/useActiveWallet.js";
import { useInternalClient } from "../../../provider/hooks/utils/useInternalClient.js";
const getStepConfig = ({
  externalWalletError
}) => {
  var _a;
  return {
    [ModalStep.EX_WALLET_SELECTED]: {
      variant: "externalWalletConnection",
      topOffset: 40,
      spacerHeight: 158,
      hideFadeOut: true
    },
    [ModalStep.CHAIN_SWITCH]: {
      variant: ((_a = externalWalletError == null ? void 0 : externalWalletError[0]) == null ? void 0 : _a.toLowerCase()) === NETWORK_NOT_SUPPORTED_ERROR ? "failed" : "externalWalletConnection",
      topOffset: 20,
      spacerHeight: 158,
      hideFadeOut: true
    },
    [ModalStep.FARCASTER_OAUTH]: {
      variant: "externalWalletConnection",
      topOffset: 40,
      spacerHeight: 158,
      hideFadeOut: true
    }
  };
};
const Hero = () => {
  const para = useInternalClient();
  const { wallet: connector, walletDisplayHelpers, avatar } = useExternalWallets();
  const step = useModalStore((state) => state.step);
  const externalWalletError = useModalStore((state) => state.externalWalletError);
  const activeWallet = useActiveWallet();
  const [currentStep, setCurrentStep] = useState(step);
  const stepConfig = getStepConfig({
    externalWalletError
  })[currentStep];
  useEffect(() => {
    const prevStepConfig = getStepConfig({
      externalWalletError
    })[currentStep];
    const newStepConfig = getStepConfig({
      externalWalletError
    })[step];
    const delay = newStepConfig && prevStepConfig ? 0 : newStepConfig && !prevStepConfig ? 0 : 200;
    setTimeout(() => {
      setCurrentStep(step);
    }, delay);
  }, [step]);
  const isExternalStep = currentStep === ModalStep.EX_WALLET_SELECTED;
  const isChainSwitchStep = currentStep === ModalStep.CHAIN_SWITCH;
  const isAccountStep = currentStep === ModalStep.ACCOUNT_MAIN;
  const isFarcasterStep = currentStep === ModalStep.FARCASTER_OAUTH;
  const { showExtension, isCosmosMobileWallet } = walletDisplayHelpers;
  const shouldHide = !stepConfig || !isMobile() && isExternalStep && !showExtension || !isMobile() && isChainSwitchStep && isCosmosMobileWallet || !isMobile() && isFarcasterStep;
  const { variant, topOffset, spacerHeight, hideFadeOut } = stepConfig != null ? stepConfig : {};
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Container, { $top: -45 + topOffset, children: shouldHide ? null : /* @__PURE__ */ jsxs(StyledHero, { $isAccount: isAccountStep, hideFadeOut, variant, height: 480, withDefaultTheme: true, children: [
      (isExternalStep || isChainSwitchStep) && /* @__PURE__ */ jsx(WalletLogo, { slot: "connectionLeft", src: connector == null ? void 0 : connector.iconUrl }),
      isFarcasterStep && /* @__PURE__ */ jsx(WalletLogo, { slot: "connectionLeft", icon: "farcasterBrand" }),
      isAccountStep && (avatar ? /* @__PURE__ */ jsx(Avatar, { slot: "image", src: avatar }) : activeWallet ? /* @__PURE__ */ jsx(IconAvatar, { slot: "image", size: "100%", hash: para.getIdenticonHash(activeWallet.id, activeWallet.type) }) : null)
    ] }) }),
    !shouldHide && /* @__PURE__ */ jsx(Spacer, { $height: spacerHeight })
  ] });
};
const Container = styled.div`
  display: flex;
  position: absolute;
  justify-content: center;
  align-items: center;
  width: 100%;

  top: ${({ $top }) => `${$top}px`};
`;
const Spacer = styled.div`
  height: ${({ $height }) => `${$height}px`};
`;
const WalletLogo = styled(CpslIcon)`
  --height: 60px;
  --width: 60px;
`;
const Avatar = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;
const IconAvatar = styled(CpslIdenticon)`
  border-radius: 1000px;
`;
const StyledHero = styled(CpslHero)`
  ${({ $isAccount }) => $isAccount && `
      --ring-3-size: 560px;
      --ring-2-size: 402px;
      --ring-1-size: 228px;
      --ring-0-size: 104px;
      
      --default-theme-ring-3-opacity: 0.02;
      --default-theme-ring-2-opacity: 0.04;
      --default-theme-ring-1-opacity: 0.06;
      --default-theme-ring-0-opacity: 0.1;
  `}
`;
export {
  Hero
};
